import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {WmComponentsModule} from "@wm/components-base";
import {CarouselModule as ngxCarouselModule} from 'ngx-bootstrap/carousel';
import {CarouselDirective} from "./carousel.directive";
import {CarouselTemplateDirective} from "./carousel-template/carousel-template.directive";
import {WmsTranscludeDirective} from "../../../../widgets/page/wms-transclude/wms-transclude.directive";

@NgModule({
    imports: [
        CommonModule,
        CarouselDirective, CarouselTemplateDirective,
        ngxCarouselModule.forRoot(),
        WmComponentsModule,
        WmsTranscludeDirective
    ],
    exports:  [CarouselDirective, CarouselTemplateDirective]
})
export  class CarouselModule {}
